<template>
  <div>
    <div class="modelReg__title">
      <h3>{{ $t('modal.modalStateEnum.WelcomeBackInGoogle.title') }}</h3>
      <p>{{ form.email }}</p>
      <p>{{ $t('modal.modalStateEnum.WelcomeBackInGoogle.subTitle') }}</p>
    </div>

    <UButton
      :label="$t('modal.modalStateEnum.WelcomeBackInGoogle.googleBtn')"
      color="black"
      size="xl"
      block
      class="mb-6"
    >
      <template #leading>
        <UAvatar src="_nuxt/assets/img/icons_google.svg" size="xs" />
      </template>
    </UButton>

    <div class="text-center">
      <UButton
        color="primary"
        variant="link"
        :label="$t('modal.modalStateEnum.WelcomeBackInGoogle.btn')"
        @click="setPassword"
      />
    </div>
  </div>
</template>

<script setup>
/* v8 ignore file */
import { modalStateEnum } from '@shared/model';
import { useAuthStore } from '~/features/auth';
import { useUserProfileStore } from '@entities/user';
const storeAuth = useAuthStore();
const storeUserProfile = useUserProfileStore();
const props = defineProps({
  userData: {
    type: Object,
    required: true,
    default: {
      email: '',
      password: '',
      confirmPassword: '',
      twoFA: '',
      codeFromEmail: '',
    },
  },
});
const form = ref(props.userData);

const setPassword = () => {
  storeModal.stateAuthModal(modalStateEnum.CodeFromEmail);
};
</script>


